module.exports = __webpack_public_path__ + "static/employable-d166b4048f4562acde3e8929651c8132.svg";